"use strict";
exports.__esModule = true;
exports.JSONCodec = exports.JSONCodecError = void 0;
var Either_1 = require("fp-ts/Either");
var io_ts_1 = require("io-ts");
exports.JSONCodecError = {
    PARSE_FAILURE: 'JSON parse failure!',
    IS_CHECK_FAILURE: '`is` check failed??',
    FIELD_FAILURE: function (key, actual, expected) {
        return "Validation failed after parse for key \"" + key + "\". Expected \"" + expected + "\", actual \"" + actual + "\"";
    }
};
/**
 * Provides an easy way to turn io-ts TypeC objects into a class which can
 * encode and decode them, providing human readable errors when there
 * are validation issues.
 *
 * Usage:
 *
 * ```
 * import * as t from 'io-ts';
 * const MyCodec = new JSONCodec(
 *  'MyCodec',
 *  t.type({
 *    hello: t.string,
 *    world: t.string,
 *  })
 * );
 *
 * // Serialize an object
 * const encoded = MyCodec.encode({hello: 'wow', world: 'ok!'});
 *
 * // Deserialize an object
 * const decoded = MyCodec.decode(encoded);
 *
 * // Get a compile-time type for the object
 * type MyCodecType = typeof MyCodec._T;
 * const x: MyCodecType = {hello: '', world: ''};
 * ```
 */
var JSONCodec = /** @class */ (function () {
    function JSONCodec(name, base) {
        this.name = name;
        this.base = base;
        this._T = this.base._O;
    }
    JSONCodec.prototype.decode = function (i) {
        var _this = this;
        // Special case for t.undefined codec
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.base === io_ts_1.undefined) {
            return i === ''
                ? (0, Either_1.right)(undefined)
                : (0, Either_1.left)(new Error(exports.JSONCodecError.PARSE_FAILURE));
        }
        var parsed;
        try {
            parsed = JSON.parse(i);
        }
        catch (err) {
            return (0, Either_1.left)(new Error(exports.JSONCodecError.PARSE_FAILURE));
        }
        var baseDecode = this.base.decode(parsed);
        if ((0, Either_1.isLeft)(baseDecode)) {
            var firstError = baseDecode.left[0];
            var lastContext = firstError.context[firstError.context.length - 1];
            return (0, Either_1.left)(new Error(exports.JSONCodecError.FIELD_FAILURE(lastContext.key, lastContext.actual, lastContext.type.name)));
        }
        var is = function (a) { return _this.base.is(a); };
        if (is(baseDecode.right))
            return (0, Either_1.right)(baseDecode.right);
        return (0, Either_1.left)(new Error(exports.JSONCodecError.IS_CHECK_FAILURE));
    };
    JSONCodec.prototype.decodeUnsafe = function (i) {
        var decoded = this.decode(i);
        if ((0, Either_1.isLeft)(decoded)) {
            throw decoded.left;
        }
        return decoded.right;
    };
    JSONCodec.prototype.encode = function (t) {
        try {
            return (0, Either_1.right)(this.encodeUnsafe(t));
        }
        catch (err) {
            return (0, Either_1.left)(err instanceof Error ? err : new Error('Failed to encode'));
        }
    };
    /**
     * same as {@link encode}, but can possibly throw.
     */
    JSONCodec.prototype.encodeUnsafe = function (t) {
        return JSON.stringify(t);
    };
    return JSONCodec;
}());
exports.JSONCodec = JSONCodec;
//# sourceMappingURL=JSONCodec.js.map